import React from "react";

const AppML_Datafiles = () => {
  return (
    <div className="tutorial-page">
      <h1>AppML Datafiles</h1>
      <p>This is the AppML Datafiles page content.</p>
    </div>
  );
};

export default AppML_Datafiles;
